export type DriverDistrict = {
  district: { id: string };
};

export function getUnusedDistrictsForDriver<T extends { id: string }>(
  availableDistricts: T[],
  driverDistricts: DriverDistrict[]
): T[] {
  return availableDistricts.filter((d) => !driverDistricts.some((dd) => dd.district.id === d.id));
}
